module.exports = __webpack_public_path__ + "assets/img/culture-item-two.5eef4a9a.png";